import React from "react";
import ExternalLinkButton from "../ui/ExternalLinkButton";

const WidgetCard = ({ text, icon, path, desc, external = false }) => {
  return (
    <ExternalLinkButton
      to={path}
      className="widget-card-link"
      external={external}
      style={{
        textDecoration: "none",
        color: "inherit",
      }}
    >
      <div className="widget-card-surface">
        <div className="widget-card-content">
          <img src={icon} alt={text} className="widget-card-icon" />
          <div>
            <h3 className="text-xl font-bold text-gray-800 mb-1">{text}</h3>
            <p className="text-sm font-medium text-gray-500">{desc}</p>
          </div>
        </div>
      </div>
    </ExternalLinkButton>
  );
};

export default WidgetCard;
